export default {
    props: ['user', 'team', 'billableType'],

    data() {
        return {
            loading: true,
            plans: [],
            stripePlans: [],
        }
    },

    created() {
        this.fetchPlans();
    },

    methods: {
        fetchPlans() {
            return this.$http
                .get(this.$laroute.route('api.plans.index'))
                .then(response => {
                    this.loading = false;
                    this.stripePlans = response.data.data;
                    this.plans = this.fiteredByAvailablePlans(this.stripePlans);
                    this.afterFetchPlans();
                });
        },

        afterFetchPlans() { },

        fiteredByAvailablePlans(plans) {
            const availablePlans = this.team.available_plans.length ? this.team.available_plans : [
                DevSquad.swellPlanBasic, DevSquad.swellPlanAdvanced
            ];

            return plans.filter(plan => availablePlans.includes(plan.id));
        },
    }
}
